import { MutationTree } from 'vuex';
import { ReportMutations, ReportState, ReportType } from './types';

export const mutations: MutationTree<ReportState> = {
  [ReportMutations.SET_SELECTED_TYPE](state, type: ReportType): void {
    state.selectedType = type;
  },
};
